import React from 'react';

import { Empty as AntdEmpty, Spin as AntdSpin } from 'antd';
import { NamePath as AntdNamePath } from 'rc-field-form/lib/interface';

import { MarqueDto, ModeleDto } from 'lib_api/lib/api/gen';

import { useBaseFormContext } from 'components/BaseForm/BaseFormContext';
import BaseSelectMultiList from 'components/BaseForm/Select/BaseSelectMultiList';
import { CommonBaseSelectProps } from 'components/BaseForm/Select/CommonBaseSelect';
import { setFieldValue } from 'components/BaseForm/utils';
import { useFetchModeles } from 'hooks/referentiels/useFetchModeles';
import { unsafeCast } from 'typeGuards/typeGuards';
import { LABEL_MODELE_NON_REFERENCE, VALUE_NON_REFERENCE } from 'utils/global';

import { BaseOptionType } from '../BaseSelect';

interface SelectModeleMultiListProps<FormValues>
  extends Omit<
    CommonBaseSelectProps<FormValues, ModeleDto | null>,
    'options' | 'getOptionValue' | 'getOptionLabel' | 'onBottomReached'
  > {
  idMarqueField: keyof FormValues & AntdNamePath;
  withCorrelationId?: boolean;
}

const modeleNonReferencee: ModeleDto = {
  id: VALUE_NON_REFERENCE,
  idCorrelation: null,
  libelle: LABEL_MODELE_NON_REFERENCE,
  prioritaire: null,
  marque: '',
};

export default function BaseSelectModeleMultiList<FormValues>({
  idMarqueField,
  withCorrelationId,
  ...props
}: SelectModeleMultiListProps<FormValues>): React.ReactElement {
  const form = useBaseFormContext<FormValues>();
  const idMarque: BaseOptionType<MarqueDto> | null =
    unsafeCast<BaseOptionType<MarqueDto> | null>(
      form.getFieldValue(idMarqueField),
    );
  const { modeles, inProgress, search, paginate } = useFetchModeles(
    false,
    idMarque,
  );
  const { modeles: modelesPrio, inProgress: inProgressPrio } = useFetchModeles(
    true,
    idMarque,
  );

  return (
    <BaseSelectMultiList
      {...props}
      options={[
        {
          label: 'Modèles fréquents',
          options: modelesPrio,
        },
        {
          label: 'Autres',
          options: [modeleNonReferencee, ...modeles],
        },
      ]}
      notFoundContent={
        inProgress || inProgressPrio ? <AntdSpin size="small" /> : <AntdEmpty />
      }
      getOptionLabel={(modele: ModeleDto) => modele.libelle}
      getOptionValue={(modele: ModeleDto) =>
        withCorrelationId ? modele.idCorrelation || '' : modele.id
      }
      showSearch
      onSearch={search}
      onBottomReached={paginate}
      onChange={(value, option) => {
        props.onChange && props.onChange(value, option);
        if (option && props.id) {
          setFieldValue(form, props.id, option);
        }
      }}
      allowClear={true}
    />
  );
}
